module.exports = __webpack_public_path__ + "static/img/case_detail_07_1.22a96dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_07_1.png
// module id = 8C2z
// module chunks = 34